import { ActorType, AuditPolicy, AuthenticationAssuranceLevel, ConcurrencyPolicy, IdempotencyPolicy, PrivacyClassification, ScopeType, } from './operation.js';
/** Canonical Smart Search read operation. Scope is inherited from the authenticated session. */
export const SMART_SEARCH_QUERY = 'search.query';
/** Canonical Smart Search selection telemetry recording operation. */
export const SMART_SEARCH_SELECTION = 'search.selection.record';
export const SEARCH_OPERATIONS = {
    [SMART_SEARCH_QUERY]: {
        id: SMART_SEARCH_QUERY,
        name: 'Search Authorized Organization Experience',
        implementationStatus: 'AVAILABLE',
        labelKey: 'operations.search.query.label',
        descriptionKey: 'operations.search.query.description',
        permission: 'navigation:read',
        permissionId: 'navigation:read',
        module: 'NAVIGATION',
        requiredModules: ['NAVIGATION'],
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM],
        allowedScopeKinds: ['ORGANIZATION', 'BRANCH', 'CLIENT', 'PORTFOLIO'],
        allowedPersonas: ['ORG_ADMIN', 'ORG_USER', 'ORG_CLIENT'],
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.RESTRICTED,
        telemetryId: SMART_SEARCH_QUERY,
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT, ActorType.SUPPORT_DELEGATE],
        httpMethods: ['POST'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: true,
        delegationPolicy: 'EXPLICITLY_GRANTED',
        accessType: 'READ',
    },
    [SMART_SEARCH_SELECTION]: {
        id: SMART_SEARCH_SELECTION,
        name: 'Record Search Selection Telemetry',
        implementationStatus: 'AVAILABLE',
        labelKey: 'operations.search.selection.label',
        descriptionKey: 'operations.search.selection.description',
        permission: 'navigation:read',
        permissionId: 'navigation:read',
        module: 'NAVIGATION',
        requiredModules: ['NAVIGATION'],
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM],
        allowedScopeKinds: ['ORGANIZATION', 'BRANCH', 'CLIENT', 'PORTFOLIO'],
        allowedPersonas: ['ORG_ADMIN', 'ORG_USER', 'ORG_CLIENT'],
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.NONE,
        privacyClassification: PrivacyClassification.RESTRICTED,
        telemetryId: SMART_SEARCH_SELECTION,
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT, ActorType.SUPPORT_DELEGATE],
        httpMethods: ['POST'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: true,
        delegationPolicy: 'EXPLICITLY_GRANTED',
        accessType: 'READ',
    },
};
